<template>
    <reset-password />
</template>

<script>
// import logoUrl from '@/assets/images/rainbond-online-log.svg'
import ResetPassword from './components/ResetPassword'

export default {
  name: 'ForgotPassword',
  components: {
    ResetPassword
  },
  data() {
    return {
      // logoUrl
    }
  },

  methods: {}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/resetPassword/index.vue